const formsFunctionality = ($) => {

  //FORM focus animations
  const addFocus = (input) => input.parentNode.classList.add('focused');
  const removeFocus = (input) => !input.value ? input.parentNode.classList.remove('focused') : '';
  const inputFields = [...document.getElementsByClassName('input-field')];
  inputFields.map(input => {
    if (input.value) input.classList.add('focused');
    input.addEventListener('focus', () => addFocus(input));
    input.addEventListener('blur', () => removeFocus(input));
  });

  // Contact form 7 on success submit functionality
  $('.wpcf7').each(function () {
    var $form = $(this);
    $form.on('wpcf7:mailsent', function () {
      $form.after('<div class="form-success"><div class="form-success__icon"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg></div><span>Tack för ditt mail!</span></div>');
      $form.addClass('hidden');
      window.setTimeout(function () { $('.form-success').addClass('shown'); }, 400);
    });
  });
};

export default formsFunctionality;